import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/profile")({
  component: ProfileLayout,
  staticData: {
    config: {
      title: "profile",
    },
  },
});

function ProfileLayout() {
  return <Outlet />;
}
